export const containsSection = (route: string, section: string): boolean => {
  const regex = new RegExp(`(^|/|%2F)${section}(%2F|/|$)`);
  return regex.test(route);
};

export const containsName = (route: string, name: string): boolean => {
  const regex = new RegExp(`(^|)${name}(|$)`);
  return regex.test(route);
};
